import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { MARKETING_THEME } from "@/lib/theme";

// Shared wrapper for sub-pages (navbar + light content panel + footer).
export const PageShell = ({ children, title, eyebrow }) => {
  return (
    <div className={`min-h-screen bg-oath-bg ${MARKETING_THEME} page-soft`}>
      <Navbar />
      <main className="mx-auto max-w-5xl px-5 pb-20 pt-32">
        {(title || eyebrow) && (
          <header className="mb-8 animate-fade-up">
            {eyebrow && (
              <div className="font-mono-label text-[11px] font-semibold text-oath-accent">
                {eyebrow}
              </div>
            )}
            {title && (
              <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-oath-ink sm:text-5xl">
                {title}
              </h1>
            )}
          </header>
        )}
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PageShell;
